import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../sharedComponent/Header'
import Subheader from '../../sharedComponent/Subheader';
import Accordion from 'react-bootstrap/Accordion';
import FilterImg from "../../assets/images/filterIcon.svg";
import DoctorSahab from "../../assets/images/DoctorImg.svg";
import Heart from "../../assets/images/heart.svg"
import HeartAct from "../../assets/images/heartActive.svg";
import Location from "../../assets/images/location.svg";
import Watch from "../../assets/images/watch.svg";
import Dollar from "../../assets/images/dollar.svg";
import Star from "../../assets/images/Star.svg";
import LitStar from "../../assets/images/liteStar.svg";
import BlueImgArow from "../../assets/images/darkIcon.svg";
import liteImgArow from "../../assets/images/lightIcon.svg";
import MultiRangeSlider from "multi-range-slider-react";


const DoctorsList = () => {
    const [click, setClick] = useState(false);
    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(45);
    return (
        <>
            <div className="DoctorsList" id="cx-main">
                <Subheader />

                {/* main Cards Content */}
                <div className="row">
                    {/* Left Menu's Accordians */}
                    <div className="col-md-3 ColBox30">
                        <div id="accordiansTab">
                            <div className="mainHeadTxt">
                                <h1 className='headName'>Filter</h1>
                            </div>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Specialist</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="checksPortion">
                                            <div class="form-check checkNlabel">
                                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                <label class="form-check-label" for="flexCheckDefault">
                                                    Dog Surgen
                                                </label>
                                            </div>
                                            <div class="form-check checkNlabel">
                                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault2" />
                                                <label class="form-check-label" for="flexCheckDefault2">
                                                    Dog Surgen
                                                </label>
                                            </div>
                                            <div class="form-check checkNlabel">
                                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault3" />
                                                <label class="form-check-label" for="flexCheckDefault3">
                                                    Dog Surgen
                                                </label>
                                            </div>
                                            <div class="form-check checkNlabel">
                                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault4" />
                                                <label class="form-check-label" for="flexCheckDefault4">
                                                    Dog Surgen
                                                </label>
                                            </div>
                                            <div class="form-check checkNlabel">
                                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault5" />
                                                <label class="form-check-label" for="flexCheckDefault5">
                                                    Dog Surgen
                                                </label>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Experience</Accordion.Header>
                                    <Accordion.Body>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Area</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="sliderAreas">
                                            <MultiRangeSlider
                                                min={1}
                                                max={9}
                                                step={3}
                                                minValue={minValue}
                                                maxValue={maxValue}
                                                onInput={(e: ChangeResult) => {
                                                    setMinValue(e.minValue);
                                                    setMaxValue(e.maxValue);
                                                }}
                                            ></MultiRangeSlider>
                                            <div className="belowSteps">
                                                <label htmlFor="">0 Kms</label>
                                                <label htmlFor="">25 Kms</label>
                                                <label htmlFor="">50 Kms</label>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Fees</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="sliderAreas">
                                            <MultiRangeSlider
                                                min={1}
                                                max={9}
                                                step={3}
                                                minValue={minValue}
                                                maxValue={maxValue}
                                                onInput={(e: ChangeResult) => {
                                                    setMinValue(e.minValue);
                                                    setMaxValue(e.maxValue);
                                                }}
                                            ></MultiRangeSlider>
                                            <div className="belowSteps">
                                                <label htmlFor="">100 &#8377;</label>
                                                <label htmlFor="">300 &#8377;</label>
                                                <label htmlFor="">1000 &#8377;</label>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Ratings</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="ratingStars">
                                            <img src={Star} className='me-2' alt="" />
                                            <img src={Star} className='me-2' alt="" />
                                            <img src={LitStar} className='me-2' alt="" />
                                            <img src={LitStar} className='me-2' alt="" />
                                            <img src={LitStar} alt="" />
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                    {/* Cards Content Section */}
                    <div className="col-md-9 colBox90">
                        <div className="cardsSections">
                            <div className="topFilterSection">
                                <div className="txtSec">
                                    <h1 className='mainTxt'>Doctor’s <span className='mutedTxt'>(Showing 1-20 of 500 Doctor’s)</span> </h1>
                                </div>
                                <div className="filterImg">
                                    <img src={FilterImg} alt="" />
                                </div>
                            </div>
                            <div className="scrollerAbove">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="cardsInsider">
                                            <div className="detailsCOntent">
                                                <div className="imgContainer">
                                                    <img src={DoctorSahab} className='insideImg' alt="" />
                                                </div>
                                                <div className="detailsInside">
                                                    <div className="detailsTop">
                                                        <div className="detailsTxt">
                                                            <h1 htmlFor="" className='NameTxt'>Dr. Floyd Miles</h1>
                                                            <label htmlFor="" className='domainTxt'>Orthopedic | 5 years</label>
                                                        </div>
                                                        <div className="detActionBtn">
                                                            <img onClick={() => setClick(!click)} src={click ? HeartAct : Heart} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="belowCOntent">
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Location} className='me-2' alt="" />
                                                            Animal’s Clinic, Pune
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Watch} className='me-2' alt="" />
                                                            Mon- Sat : 10:00 AM - 06:00 PM
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt belowMg3'>
                                                            <img src={Dollar} className='me-2' alt="" />
                                                            ₹100 / Visit
                                                            I
                                                            ₹200 / Video Call
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt DiffClr'>
                                                            <img src={Star} className='me-2' alt="" />
                                                            4.3
                                                            |
                                                            100 reviews
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="detailCardsBtns">
                                                <Link to="/DoctorDetails" className="DetailsBtn">
                                                    <button>View Details <img src={BlueImgArow} alt="" /></button>
                                                </Link>
                                                <Link to="#" className="bookBtn">
                                                    <button>Book Now <img src={liteImgArow} alt="" /></button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="cardsInsider">
                                            <div className="detailsCOntent">
                                                <div className="imgContainer">
                                                    <img src={DoctorSahab} className='insideImg' alt="" />
                                                </div>
                                                <div className="detailsInside">
                                                    <div className="detailsTop">
                                                        <div className="detailsTxt">
                                                            <h1 htmlFor="" className='NameTxt'>Dr. Floyd Miles</h1>
                                                            <label htmlFor="" className='domainTxt'>Orthopedic | 5 years</label>
                                                        </div>
                                                        <div className="detActionBtn">
                                                            <img onClick={() => setClick(!click)} src={click ? HeartAct : Heart} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="belowCOntent">
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Location} className='me-2' alt="" />
                                                            Animal’s Clinic, Pune
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Watch} className='me-2' alt="" />
                                                            Mon- Sat : 10:00 AM - 06:00 PM
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt belowMg3'>
                                                            <img src={Dollar} className='me-2' alt="" />
                                                            ₹100 / Visit
                                                            I
                                                            ₹200 / Video Call
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt DiffClr'>
                                                            <img src={Star} className='me-2' alt="" />
                                                            4.3
                                                            |
                                                            100 reviews
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="detailCardsBtns">
                                                <Link to="/DoctorDetails" className="DetailsBtn">
                                                    <button>View Details <img src={BlueImgArow} alt="" /></button>
                                                </Link>
                                                <Link to="#" className="bookBtn">
                                                    <button>Book Now <img src={liteImgArow} alt="" /></button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="cardsInsider">
                                            <div className="detailsCOntent">
                                                <div className="imgContainer">
                                                    <img src={DoctorSahab} className='insideImg' alt="" />
                                                </div>
                                                <div className="detailsInside">
                                                    <div className="detailsTop">
                                                        <div className="detailsTxt">
                                                            <h1 htmlFor="" className='NameTxt'>Dr. Floyd Miles</h1>
                                                            <label htmlFor="" className='domainTxt'>Orthopedic | 5 years</label>
                                                        </div>
                                                        <div className="detActionBtn">
                                                            <img onClick={() => setClick(!click)} src={click ? HeartAct : Heart} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="belowCOntent">
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Location} className='me-2' alt="" />
                                                            Animal’s Clinic, Pune
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Watch} className='me-2' alt="" />
                                                            Mon- Sat : 10:00 AM - 06:00 PM
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt belowMg3'>
                                                            <img src={Dollar} className='me-2' alt="" />
                                                            ₹100 / Visit
                                                            I
                                                            ₹200 / Video Call
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt DiffClr'>
                                                            <img src={Star} className='me-2' alt="" />
                                                            4.3
                                                            |
                                                            100 reviews
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="detailCardsBtns">
                                                <Link to="/DoctorDetails" className="DetailsBtn">
                                                    <button>View Details <img src={BlueImgArow} alt="" /></button>
                                                </Link>
                                                <Link to="#" className="bookBtn">
                                                    <button>Book Now <img src={liteImgArow} alt="" /></button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="cardsInsider">
                                            <div className="detailsCOntent">
                                                <div className="imgContainer">
                                                    <img src={DoctorSahab} className='insideImg' alt="" />
                                                </div>
                                                <div className="detailsInside">
                                                    <div className="detailsTop">
                                                        <div className="detailsTxt">
                                                            <h1 htmlFor="" className='NameTxt'>Dr. Floyd Miles</h1>
                                                            <label htmlFor="" className='domainTxt'>Orthopedic | 5 years</label>
                                                        </div>
                                                        <div className="detActionBtn">
                                                            <img onClick={() => setClick(!click)} src={click ? HeartAct : Heart} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="belowCOntent">
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Location} className='me-2' alt="" />
                                                            Animal’s Clinic, Pune
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Watch} className='me-2' alt="" />
                                                            Mon- Sat : 10:00 AM - 06:00 PM
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt belowMg3'>
                                                            <img src={Dollar} className='me-2' alt="" />
                                                            ₹100 / Visit
                                                            I
                                                            ₹200 / Video Call
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt DiffClr'>
                                                            <img src={Star} className='me-2' alt="" />
                                                            4.3
                                                            |
                                                            100 reviews
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="detailCardsBtns">
                                                <Link to="/DoctorDetails" className="DetailsBtn">
                                                    <button>View Details <img src={BlueImgArow} alt="" /></button>
                                                </Link>
                                                <Link to="#" className="bookBtn">
                                                    <button>Book Now <img src={liteImgArow} alt="" /></button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="cardsInsider">
                                            <div className="detailsCOntent">
                                                <div className="imgContainer">
                                                    <img src={DoctorSahab} className='insideImg' alt="" />
                                                </div>
                                                <div className="detailsInside">
                                                    <div className="detailsTop">
                                                        <div className="detailsTxt">
                                                            <h1 htmlFor="" className='NameTxt'>Dr. Floyd Miles</h1>
                                                            <label htmlFor="" className='domainTxt'>Orthopedic | 5 years</label>
                                                        </div>
                                                        <div className="detActionBtn">
                                                            <img onClick={() => setClick(!click)} src={click ? HeartAct : Heart} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="belowCOntent">
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Location} className='me-2' alt="" />
                                                            Animal’s Clinic, Pune
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Watch} className='me-2' alt="" />
                                                            Mon- Sat : 10:00 AM - 06:00 PM
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt belowMg3'>
                                                            <img src={Dollar} className='me-2' alt="" />
                                                            ₹100 / Visit
                                                            I
                                                            ₹200 / Video Call
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt DiffClr'>
                                                            <img src={Star} className='me-2' alt="" />
                                                            4.3
                                                            |
                                                            100 reviews
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="detailCardsBtns">
                                                <Link to="/DoctorDetails" className="DetailsBtn">
                                                    <button>View Details <img src={BlueImgArow} alt="" /></button>
                                                </Link>
                                                <Link to="#" className="bookBtn">
                                                    <button>Book Now <img src={liteImgArow} alt="" /></button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="cardsInsider">
                                            <div className="detailsCOntent">
                                                <div className="imgContainer">
                                                    <img src={DoctorSahab} className='insideImg' alt="" />
                                                </div>
                                                <div className="detailsInside">
                                                    <div className="detailsTop">
                                                        <div className="detailsTxt">
                                                            <h1 htmlFor="" className='NameTxt'>Dr. Floyd Miles</h1>
                                                            <label htmlFor="" className='domainTxt'>Orthopedic | 5 years</label>
                                                        </div>
                                                        <div className="detActionBtn">
                                                            <img onClick={() => setClick(!click)} src={click ? HeartAct : Heart} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="belowCOntent">
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Location} className='me-2' alt="" />
                                                            Animal’s Clinic, Pune
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt'>
                                                            <img src={Watch} className='me-2' alt="" />
                                                            Mon- Sat : 10:00 AM - 06:00 PM
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt belowMg3'>
                                                            <img src={Dollar} className='me-2' alt="" />
                                                            ₹100 / Visit
                                                            I
                                                            ₹200 / Video Call
                                                        </h1>
                                                        <h1 htmlFor="" className='belowTxt DiffClr'>
                                                            <img src={Star} className='me-2' alt="" />
                                                            4.3
                                                            |
                                                            100 reviews
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="detailCardsBtns">
                                                <Link to="/DoctorDetails" className="DetailsBtn">
                                                    <button>View Details <img src={BlueImgArow} alt="" /></button>
                                                </Link>
                                                <Link to="#" className="bookBtn">
                                                    <button>Book Now <img src={liteImgArow} alt="" /></button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center">
                                        <button className='showMoreBtn'>Show More</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DoctorsList
